/**
 * Country Group section (on Homepage; Graduating, Continuing, Inception)
 */

import React from "react";
import parse from "html-react-parser";
import { kebabCase } from "lodash";
import CountryCard from "./country-card";
import "../styles/bg-page-circles.css";
import CopyLinkButton from "./copy-link-button";

const CountryGroup = ({ props }) => {
  
  return (
    <section
      key={props.heading ||
        props.includeInStickyMenu?.menuTitle}
      className="section relative transparent p-section-half bg-page-circles"
    >
      <div className="container grid gap-8 xl:gap-12 2xl:gap-20">
        <div>
          <div className="group-copy-link group">
            {props.heading ? (
              <>
                <h2
                  className="mb-4 max-w-2xl anchor-heading"
                  id={kebabCase(props.heading).replace(/[0-9]/g, '')}
                >
                  {props.heading}
                </h2>
                <CopyLinkButton heading={props.heading} />
              </>
            ) : props.includeInStickyMenu?.menuTitle ? (
              <div id={kebabCase(props.includeInStickyMenu.menuTitle) || ""}>
                <CopyLinkButton heading={props.includeInStickyMenu.menuTitle} />
              </div>
            ) : null}
          </div>
          {props.leadContent ? (
            <div
              className={`parsed-content max-w-2xl ${props.includeIcons ? "-mb-4" : ""}`}
            >
              {parse(props.leadContent)}
            </div>
          ) : null}
        </div>
        <ol className="grid grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-8 sm:gap-12 lg:gap-8 xl:gap-12">
          {props.countries?.map((country) => {
            const title = country.hero?.mainHeading || country.title;
            return (
              <li key={country.title}>
                <CountryCard country={country} title={title} />
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
};

export default CountryGroup;
